module.exports = __webpack_public_path__ + "static/logos/surf-forecast__logo--white-cacba159be8be783e334e3f69e17f57f.svg";